import { Component, ComponentType } from 'react';
import { useNavigate, useLocation, useParams, NavLink } from 'react-router-dom';
import { Button, Card, Nav, ButtonGroup } from 'react-bootstrap';

import BCard from '../../../framework/component/container/BCard';

import 'bootstrap/dist/css/bootstrap.min.css';

import './QuizStart.css'

interface CourseCompletedProps {
    courseName: string;
    message: string;
}

const PAGE_TITLE = "AMS - Test";

class CourseCompleted extends Component<CourseCompletedProps> {

    constructor(props: CourseCompletedProps) {
        super(props);
    }

    componentDidMount() {
        document.title = PAGE_TITLE;
    }

    render() {
        const { courseName, message } = this.props;

        return (
            <BCard title={courseName + ' Completed'}
                contentPanel={<>
                    {message}
                </>}
                bottomPanel={<>
                    <Nav.Link eventKey="home" href="/ams/resProfile">
                        <Button variant="primary">Return to Profile</Button>
                    </Nav.Link>
                </>}
            />
        )
    };
}

export default CourseCompleted;
